/**
 * i18n 类型定义
 * 支持多语言扩展和 RTL 布局
 */

// 支持的语言代码
export type LanguageCode = 'en' | 'zh-CN' | 'ja' | 'ar' | 'es' | 'ko' | 'pt-BR';

// 当前已激活的语言
export type ActiveLanguage = 'en' | 'zh-CN' | 'ja';

// 语言元数据
export interface LanguageMetadata {
  code: LanguageCode;
  name: string;
  nativeName: string;
  flag: string;
  isRTL: boolean;
  isActive: boolean; // 是否已上线
}

// 语言配置列表
export const SUPPORTED_LANGUAGES: LanguageMetadata[] = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸', isRTL: false, isActive: true },
  { code: 'zh-CN', name: '简体中文', nativeName: '简体中文', flag: '🇨🇳', isRTL: false, isActive: true },
  { code: 'ja', name: '日本語', nativeName: '日本語', flag: '🇯🇵', isRTL: false, isActive: true },
  // 预留扩展语言（未激活）
  { code: 'ar', name: 'العربية', nativeName: 'العربية', flag: '🇸🇦', isRTL: true, isActive: false },
  { code: 'es', name: 'Español', nativeName: 'Español', flag: '🇪🇸', isRTL: false, isActive: false },
  { code: 'ko', name: '한국어', nativeName: '한국어', flag: '🇰🇷', isRTL: false, isActive: false },
  { code: 'pt-BR', name: 'Português', nativeName: 'Português', flag: '🇧🇷', isRTL: false, isActive: false },
];

// 获取激活的语言
export const getActiveLanguages = (): LanguageMetadata[] => 
  SUPPORTED_LANGUAGES.filter(lang => lang.isActive);

// 检查语言是否激活
export const isLanguageActive = (code: LanguageCode): boolean =>
  SUPPORTED_LANGUAGES.find(l => l.code === code)?.isActive ?? false;

// 检查是否为 RTL 语言
export const isRTL = (code: LanguageCode): boolean =>
  SUPPORTED_LANGUAGES.find(l => l.code === code)?.isRTL ?? false;

// 翻译函数参数类型
export type TranslationParams = Record<string, string | number>;

// 嵌套翻译对象类型
export type TranslationValue = string | { [key: string]: TranslationValue };
export type TranslationDict = Record<string, TranslationValue>;

// 翻译 key 类型
export type TranslationKey = string;
